<template>
  <div id="project-landing">
    <Hero
      v-bind:title="'Project: ' + project.name"
      v-bind:planTheme="planTheme"
    >
      <h2>{{ project.description }}</h2>
      <TabNav v-bind:menu="tabMenu" />
    </Hero>

    <section id="group-content">
      <Breadcrumb v-bind:crumbs="breadcrumbs" />
      <router-view></router-view>
    </section>
  </div>
</template>

<script>
import Hero from "@/components/plans/Hero.vue";
import TabNav from "@/components/TabNav.vue";
import Breadcrumb from "@/components/Breadcrumb.vue";

import { projectService } from "@/services/project.service";
import { planService } from "@/services/plan.service";

export default {
  name: "Project",
  components: {
    Hero,
    TabNav,
    Breadcrumb,
  },
  data() {
    return {
      project: {},
      tabMenu: [
        {
          name: "Project",
          link: "/project/" + this.$route.params.projectId,
        },
        {
          name: this.$t("views.project.tab.history"),
          link: "/project/" + this.$route.params.projectId + "/history",
        },
        {
          name: this.$t("views.project.tab.edit"),
          link: "/project/" + this.$route.params.projectId + "/edit",
        },
      ],
      breadcrumbs: [],
      planTheme: "",
    };
  },
  created: function () {
    this.checkWhitelistAccess();
  },
  methods: {
    fetchProject: function () {
      // grab the project
      projectService
        .getProject(this.$route.params.projectId)
        .then((project) => {
          this.project = project;
          if (project.description) {
            this.project.description = decodeURIComponent(
              atob(project.description)
            );
          }

          planService.getPlanByMember(project.planId).then((plan) => {
            this.planTheme = plan.theme;
          });
          // Build up the Breadcrumb
          this.breadcrumbs.push({
            name: project.planName,
            link: "/plan/" + project.planId,
          });
          this.breadcrumbs.push({
            name: project.groupName,
            link: "/group/" + project.groupId,
          });
          this.breadcrumbs.push({
            name: project.name,
          });
        })
        .catch((err) => {
          console.error("something went wrong fetching project: ", err);
          this.$router.push("/plans");
        });
    },
    checkWhitelistAccess: function () {
      projectService
        .whitelistAccess(this.$route.params.projectId)
        .then((res) => {
          if (res) {
            this.fetchProject();
          } else {
            this.$router.push("/error?err=403");
          }
        });
    },
  },
  beforeRouteUpdate(to, from, next) {
    if (from.path === "/project/" + this.$route.params.projectId + "/edit") {
      this.breadcrumbs = [];
      this.fetchProject();
    }
    next();
  },
};
</script>

<style lang="scss">
.content-wrapper {
  max-width: 1440px;
  margin: 0 auto;
  padding: 0 70px;
}
</style>
